<template>
  <div class="app-form">
    <return-button class="mb-4" @click="$emit('close')"></return-button>
    <form @submit.prevent="$emit('add', app)">
      <div class="flex-sb-adaptive">
        <form-group label="Название" class="mb-4">
          <custom-input type="text" v-model="app.title" required />
        </form-group>
        <form-group label="Пакет" class="mb-4">
          <custom-input type="text" placeholder="com.alfa.superapp" v-model="app.packageName" required />
        </form-group>
      </div>
      <div class="flex-sb-adaptive">
        <form-group label="Иконка (png, 512x512)" class="mb-4">
          <input type="file" @change="e => app.icon = e.target.files[0]" required />
        </form-group>
        <form-group label="Разработчик" class="mb-4">
          <select2 uri="developers"
                   v-model="app.DeveloperId"
                   field="title"
                   :limit="500"
                   :preset-value="app.Developer" />
        </form-group>
        <form-group label="Офферная ссылка" class="mb-4">
          <custom-input type="text" v-model="app.url" required />
        </form-group>
      </div>
      <div class="flex-sb-adaptive">
        <form-group label="Название версии" class="mb-4">
          <custom-input type="text" placeholder="1.0" v-model="app.versionName" required />
        </form-group>
        <form-group label="Код версии" class="mb-4">
          <custom-input type="number" placeholder="1" v-model="app.versionCode" required />
        </form-group>
      </div>
      <form-group label="Шаблон" class="mb-4">
        <select2 uri="backend-templates"
                 v-model="app.backendTemplateId"
                 field="title"
                 :limit="500"
                  />
      </form-group>
      <form-group v-for="field in app.additionalFields" :key="field.name"
                  class="mb-4"
                  :label="field.title"
                  :inline="field.connection && field.connection.role === 'master'"
                  :show-label="!field.connection || !field.connection.role || field.connection.role === 'master' || slavesShow[field.connection.entity]">
        <input type="checkbox"
               v-if="field.connection && field.connection.role === 'master'"
               @click="event => onChangeAdditionalFieldShow(field, event)" >
        <div v-if="!field.connection || !field.connection.role || slavesShow[field.name] || slavesShow[field.connection.entity]"
              class="mt-1 w-100" >
          <custom-input type="text"
                 v-if="!field.type || field.type === 'string'"
                 :placeholder="field.placeholder"
                 v-model="field.value"
                 :required="!!Number(field.required)" />
          <custom-select v-else-if="field.type === 'enum'"
                  v-model="field.value"
                  :required="!!Number(field.required)"
                  :options="field.options" />
          <custom-input type="file"
                        v-else-if="field.type === 'file'"
                        @change="e => field.value = e.target.files[0]"
                         :required="!!Number(field.required)" />
        </div>
      </form-group>
      <r-button type="submit">Добавить</r-button>
    </form>
  </div>
</template>

<script>
  import ReturnButton from './UIComponents/ReturnButton';
  import RButton from './UIComponents/RButton';
  import Select2 from './UIComponents/Select2';
  import FormGroup from './UIComponents/FormGroup';
  import CustomInput from './UIComponents/CustomInput';
  import CustomSelect from './UIComponents/CustomSelect'

  export default {
    components: {
      ReturnButton,
      RButton,
      Select2,
      FormGroup,
      CustomInput,
      CustomSelect
    },
    props: {
      app: Object
    },
    watch: {
      'app.backendTemplateId': function (backendTemplateId) {
        this.setAdditionalFields(backendTemplateId);
      }
    },
    data() {
      return {
        slavesShow: {}
      }
    },
    methods: {
      setAdditionalFields(backendTemplateId) {
        let app = this.app;
        if (!backendTemplateId)
          return app.additionalFields = [];
        this.$API.get('backend-templates', { params: { id: backendTemplateId } })
          .then(response => {
            app.additionalFields = response.data.rows[0].additional_fields
              .map(field => {
                field.value = '';
                return field;
              });
            app.additionalFields.forEach(field => {
              if (field.connection && field.connection.role === 'master')
                this.$set(this.slavesShow, field.name, false);
            });
          });
      },
      onChangeAdditionalFieldShow(field, event) {
        this.slavesShow[field.name] = event.target.checked;
        let app = this.app;
        app.additionalFields.forEach(f => {
          if (f.name === field.name || (f.connection && f.connection.entity === field.name))
            f.value = '';
        });
      }
    },
    created() {
      let app = this.app;
      if (!app.additionalFields)
        this.$set(app, 'additionalFields', []);
    }
  }
</script>

<style scoped>
.app-form {
  max-width: 900px;
  margin: 0 auto;
}
</style>